import { useState } from 'react';
import { FormModal } from './FormModal';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const integrationTimelines = [
  'Immediate (0-3 months)',
  'Near-term (3-6 months)',
  'Medium-term (6-12 months)',
  'Long-term (12+ months)',
  'Exploratory/Research'
];

export const SDKEnquiryForm = ({ isOpen, onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    organization: '',
    platform_description: '',
    integration_timeline: '',
    technical_contact: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/forms/sdk-enquiry`, formData);
      if (response.data.success) {
        toast.success('SDK Enquiry Submitted', {
          description: response.data.message
        });
        onClose();
        setFormData({
          full_name: '',
          email: '',
          organization: '',
          platform_description: '',
          integration_timeline: '',
          technical_contact: ''
        });
      }
    } catch (error) {
      toast.error('Submission Failed', {
        description: 'Please try again later.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="SDK Integration Enquiry">
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="sdk-enquiry-form">
        <p className="text-sm text-slate-600 mb-6">
          Submit an enquiry for SAIL SDK integration. Technical documentation will be provided upon review.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Full Name *</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="sdk-input-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="sdk-input-email"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Organization *</label>
            <input
              type="text"
              name="organization"
              value={formData.organization}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="sdk-input-org"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Technical Contact</label>
            <input
              type="text"
              name="technical_contact"
              value={formData.technical_contact}
              onChange={handleChange}
              placeholder="Name or email of technical lead"
              className="input-institutional"
              data-testid="sdk-input-contact"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Platform Description *</label>
          <textarea
            name="platform_description"
            value={formData.platform_description}
            onChange={handleChange}
            required
            placeholder="Describe your platform, user base, and safeguarding requirements..."
            className="textarea-institutional"
            rows={4}
            data-testid="sdk-textarea-description"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Integration Timeline</label>
          <select
            name="integration_timeline"
            value={formData.integration_timeline}
            onChange={handleChange}
            className="select-institutional"
            data-testid="sdk-select-timeline"
          >
            <option value="">Select timeline...</option>
            {integrationTimelines.map(timeline => (
              <option key={timeline} value={timeline}>{timeline}</option>
            ))}
          </select>
        </div>

        <div className="flex gap-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="btn-secondary flex-1"
            data-testid="sdk-btn-cancel"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="btn-primary flex-1 disabled:opacity-50"
            data-testid="sdk-btn-submit"
          >
            {isSubmitting ? 'Submitting...' : 'Submit Enquiry'}
          </button>
        </div>
      </form>
    </FormModal>
  );
};
